export default "__VITE_ASSET__CQBQag8H__"